import React from "react";

function HeartFilled({ size = 16 }) {
  return (
    <svg
      width={size}
      height={size}
      aria-hidden="true"
      focusable="false"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.8933 3.07333C13.5528 2.73267 13.1485 2.46243 12.7036 2.27805C12.2586 2.09368 11.7817 1.99878 11.3 1.99878C10.8183 1.99878 10.3414 2.09368 9.89643 2.27805C9.45145 2.46243 9.04717 2.73267 8.70666 3.07333L8 3.78L7.29333 3.07333C6.60554 2.38553 5.67269 1.99914 4.7 1.99914C3.72731 1.99914 2.79446 2.38553 2.10666 3.07333C1.41887 3.76112 1.03247 4.69397 1.03247 5.66666C1.03247 6.63935 1.41887 7.5722 2.10666 8.26L2.81333 8.96666L8 14.1533L13.1867 8.96666L13.8933 8.26C14.234 7.91949 14.5042 7.51521 14.6886 7.07023C14.873 6.62526 14.9679 6.14832 14.9679 5.66666C14.9679 5.185 14.873 4.70807 14.6886 4.26309C14.5042 3.81812 14.234 3.41383 13.8933 3.07333Z"
        fill="url(#paint0_linear_7093_99345)"
        stroke="url(#paint1_linear_7093_99345)"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_7093_99345"
          x1="8.00018"
          y1="1.99878"
          x2="8.00018"
          y2="14.1533"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716DFF" />
          <stop offset="1" stopColor="#20DEFB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_7093_99345"
          x1="8.00018"
          y1="1.99878"
          x2="8.00018"
          y2="14.1533"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716DFF" />
          <stop offset="1" stopColor="#20DEFB" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default HeartFilled;
